// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "9eef44f5-dirty",
    "hash": "9eef44f5",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "9eef44f5-dirty",
    "semverString": null,
    "version": "1.84.0",
    "lastUpdated": "07/29/2020"
};
/* tslint:enable */
